"use client";

import React, { createContext, useContext, useState, type ReactNode } from "react";

interface MenuContextValue {
    activeMenu: string;
    setActiveMenu: React.Dispatch<React.SetStateAction<string>>;
}

const MenuContext = createContext<MenuContextValue | null>(null);

export const useMenu = () => {
    const ctx = useContext(MenuContext);
    if (!ctx) throw new Error("useMenu must be used within MenuProvider");
    return ctx;
};

export const MenuProvider = ({ children }: { children: ReactNode }) => {
    const [activeMenu, setActiveMenu] = useState("");
    return <MenuContext.Provider value={{ activeMenu, setActiveMenu }}>{children}</MenuContext.Provider>;
};
